import inViewport from 'in-viewport'
import jQuery from 'jquery'

class Headlines {
  constructor(element) {
    if (!element) {
      return false
    }

    const nextElement = element.nextElementSibling
    const offset = window.innerHeight / 2
    const halfSize = jQuery(element).outerHeight() / 2
    const headlinesSticky = jQuery('.s-headlines-sticky')

    const watcher = inViewport(nextElement, { offset: -offset }, () => {
      headlinesSticky.addClass('is-in-viewport')
      setTimeout(watcher.watch, 500)
    })

    jQuery(window).on('scroll', () => {
      const scrollTop = jQuery(window).scrollTop()

      if (scrollTop <= halfSize) {
        headlinesSticky.removeClass('is-in-viewport')
      }
    })
  }
}
export default Headlines
